<template>
    <button class="btn btn btn-success w-100" type="button" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Carregando...
    </button>
</template>
<style>
</style>